var $43b800e97c901737$exports = {};
$43b800e97c901737$exports = {
    "longPressMessage": `Long press or press Alt + ArrowDown to open menu`
};


export {$43b800e97c901737$exports as default};
//# sourceMappingURL=en-US.mjs.map
